<template>
  <div class="login-box">
    <!-- 导航 -->
    <RMTopDiv :scroll100="scroll100" :scroll700="scroll700"></RMTopDiv>
    <!-- 视频 -->
    <div style="position: relative;">
      <video src="https://yuyunrj.oss-cn-shenzhen.aliyuncs.com/video/zhaomeiw_official_video.mp4" class="index_video" autoplay="true" muted loop="true"></video>
    </div>
    <!-- 手风琴 -->
    <div class="bag_1" style="color: white;font-size: 24px;position: relative;">
        <img src="../../static/img/rm_log_img/img_log_back_one.png" alt="" style="width: 100%;min-width: 1500px;">
        <div style="position: absolute;top: 0px;width: 82%;margin-left: 9%;">
            <div style="width: 100%; padding-top: 48px; padding-bottom: 32px">
                <div style="text-align: center;font-size: 24px;color: #000;">美服在线SAAS经营管理体系</div>
                <div style="text-align: center;font-size: 16px;color: #4B4B4B;margin-top: 10px;">智美时代·赋能美业</div>
            </div>
            <div style="display: inline-block;width: 34.2%;">
                <div class="img_1">
                    <img src="../../static/img/back_icon_2.png" alt="" style="width: 100%;">
                </div>
                <div class="img_1">
                    <img src="../../static/img/back_icon_3.png" alt="" style="width: 100%;margin-top: 2%;">
                </div>            
            </div>
            <div style="display: inline-block;width: 28.5%;margin-left: 0.8%;">
                <div class="img_1">
                    <img src="../../static/img/back_icon_1.png" alt="" style="width: 100%;">
                </div>
            </div>
            <div style="display: inline-block;width: 34.2%;margin-left: 0.8%;">
                <div class="img_1">
                    <img src="../../static/img/back_icon_5.png" alt="" style="width: 100%;">
                </div>
                <div class="img_1">
                    <img src="../../static/img/back_icon_4.png" alt="" style="width: 100%;margin-top: 2%;">
                </div>            
            </div>
        </div>
    </div>
    <div class="bag_1" style="color: white;position: relative;margin-top: 32px;background-color: rgb(244, 245, 249);">
        <div style="width: 98.5%;margin-left: 1%;padding-bottom: 32px;">
            <div style="width: 100%; padding-top: 48px; padding-bottom: 42px">
                <div style="text-align: center;font-size: 24px;color: #000;">因为相信，所以选择，因为专业，所以合作</div>
                <div style="text-align: center;font-size: 16px;color: #4B4B4B;margin-top: 10px;">他们，都在用“美服在线”</div>
            </div>
            <div style="width:100%;margin:0 auto;font-size: 90%;color: black;display: flex;min-width:1500px;">
                <!-- 左边 -->
                <div style="display: inline-block;width: 40.3%;">
                    <div v-for="(item, index) in arrayOne" :key="index" class="div_box_back_one div_center_p div_center_back">
                        <div style="padding-left: 5%;display: flex;padding-top: 4%;">
                            <img :src="item.icon_name" alt="" class="div_content_icon" >
                            <span class="div_content_name" >{{item.name}}({{item.number}})</span>
                        </div>
                        <div style="margin-top: 12px;">
                            <img v-if="item.icon_name.length > 1" :src="item.img_name" alt="" class="div_content_img">
                        </div>
                        <div class="div_center" @click="viewMore_click(item)" style="cursor: pointer;">
                            <div style="text-align: center;width: 100%;font-size: 12px;margin-top: 30%;">{{item.address}}</div>
                            <div class="div_content_text">点击查看详情</div>
                        </div>
                    </div>
                </div>
                <!-- 中间 -->
                <div style="width: 19.4%;">
                    <div style="display: flex;">
                        <div v-for="(item, index) in array_center_top" :key="index" class="div_box_back_one div_center_p div_center_back_two" :style="{'margin-right':index==0 ? '3.5%' : '0px'}">
                            <div style="padding-left: 5%;display: flex;padding-top: 4%;">
                                <img :src="item.icon_name" alt="" class="div_content_icon" >
                                <span class="div_content_name" >{{item.name}}({{item.number}})</span>
                            </div>
                            <div style="margin-top: 8%;">
                                <img v-if="item.icon_name.length > 1" :src="item.img_name" alt="" class="div_content_img">
                            </div>
                            <div class="div_center" @click="viewMore_click(item)" style="cursor: pointer;">
                                <div style="text-align: center;width: 100%;font-size: 12px;margin-top: 30%;">{{item.address}}</div>
                                <div class="div_content_text" style="text-align: center;width: 100%;">点击查看详情</div>
                            </div>
                        </div>
                    </div>
                    <div style="margin: 10px 0px 0px 0px;">
                        <div class="div_box_back_two div_center_p" style="position: relative;">
                            <div style="padding-left: 8%;display: flex;padding-top: 9%;">
                                <img :src="div_center_model.icon_name" alt="" class="div_content_icon">
                                <span style="margin: 2% 0 0 3%;font-size: 170%;">{{div_center_model.name}}({{div_center_model.number}})</span>
                            </div>
                            <div style="margin-top: 5%;padding-bottom: 5%;">
                                <img :src="div_center_model.img_name" alt="" style="width: 84%;margin: 1% 8% 0%;">
                            </div>
                            <div class="div_center" @click="viewMore_click(div_center_model)" style="cursor: pointer;">
                                <div style="text-align: center;width: 100%;font-size: 20px;margin-top: 30%;">{{div_center_model.address}}</div>
                                <div class="div_content_text" style="text-align: center;width: 100%;font-size: 22px;">点击查看详情</div>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex;">
                        <div v-for="(item, index) in array_center_bottom" :key="index" class="div_box_back_one div_center_p div_center_back_two" :style="{'margin-right':index==0 ? '3.5%' : '0px'}">
                            <div style="padding-left: 5%;display: flex;padding-top: 4%;">
                                <img :src="item.icon_name" alt="" class="div_content_icon" >
                                <span class="div_content_name" >{{item.name}}({{item.number}})</span>
                            </div>
                            <div style="margin-top: 8%;">
                                <img v-if="item.img_name.length > 1" :src="item.img_name" alt="" class="div_content_img">
                            </div>
                            <div class="div_center" @click="viewMore_click(item)" style="cursor: pointer;">
                                <div style="text-align: center;width: 100%;font-size: 12px;margin-top: 30%;">{{item.address}}</div>
                                <div class="div_content_text" style="text-align: center;width: 100%;">点击查看详情</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 右边 -->
                <div style="display: inline-block;width: 40.3%;margin-left: 0px;">
                    <div v-for="(item, index) in arrayTwo" :key="index" class="div_box_back_one div_center_p div_center_back">
                        <div style="padding-left: 5%;display: flex;padding-top: 4%;">
                            <img :src="item.icon_name" alt="" class="div_content_icon" >
                            <span class="div_content_name" >{{item.name}}({{item.number}})</span>
                        </div>
                        <div style="margin-top: 12px;">
                            <img v-if="item.img_name.length > 1" :src="item.img_name" alt="" class="div_content_img">
                        </div>
                        <div class="div_center" @click="viewMore_click(item)" style="cursor: pointer;">
                            <div style="text-align: center;width: 100%;font-size: 12px;margin-top: 30%;">{{item.address}}</div>
                            <div class="div_content_text" style="text-align: center;width: 100%;">点击查看详情</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bag_1" style="margin-bottom: 30px;width: 98%;margin-left: 1.5%;">
        <div style="display: inline-block;width: 47.5%;padding: 0px;margin: 0px;">
            <div v-for="(item,index) in img_array" style="display: inline-block;width: 9.4%;" :key="index" :style="{'margin-left':(index == 0 || index == 10 || index == 20 || index == 30 || index == 40 || index == 50 || index == 60 || index == 70 || index == 80) ? '0px' : '0.6%'}">
                <img :src="item" alt="" style="width: 100%;" class="div_img_h">
            </div>
        </div>
        <div style="display: inline-block;width: 3.6%;padding: 0px 0.3%;">
            <img src="../../static/img/img_left_icon/img_center_back.png" alt="" style="width: 100%;margin-bottom: 70%;">
        </div>
        <div style="display: inline-block;width: 47.5%;">
            <div v-for="(item, index) in img_right_array" :key="index" style="display: inline-block;width: 9.4%;padding: 0px;margin: 0px;margin-right: 0.6%;" v-if="index < 20">
                <img :src="item" alt="" style="width: 100%;" class="div_img_h">
            </div>
            <div style="width: 100%;padding: 0px;margin: 0px;display: flex;">
                <div style="width: 30%;clear: both;">
                    <div v-for="(item, index) in img_right_array" :key="index" class="div_img_back" :style="{'margin-right':(index == 22 || index == 32 || index == 42 || index == 52) ? '0px' : '1.5%'}" v-if="index >= 20 && index <= 22 || index >= 30 && index <= 32 || index >= 40 && index <= 42 || index >= 50 && index <= 52">
                        <img :src="item" alt="" style="width: 100%;" class="div_img_h">
                    </div>
                </div>
                <div style="width: 40%;">
                    <div v-for="(item, index) in img_right_array" :key="index" style="display: inline-block;width: 48.6%;" :style="{'margin-right':(index == 25 || index == 45) ? '0px' : '4.5px'}" v-if="index == 23 || index == 25 || index == 43 || index == 45">
                        <img :src="item" alt="" style="width: 100%;" class="div_img_h">
                    </div>
                </div>
                <div style="width: 30%;">
                    <div v-for="(item, index) in img_right_array" :key="index" class="div_img_back" :style="{'margin-left':(index == 27 || index == 37 || index == 47 || index == 57) ? '0px' : '1.8%'}" v-if="index >= 27 && index <= 29 || index >= 37 && index <= 39 || index >= 47 && index <= 49 || index >= 57 && index <= 59">
                        <img :src="item" alt="" style="width: 100%;" class="div_img_h">
                    </div>
                </div>
            </div>
            <div v-for="(item, index) in img_right_array" :key="index" style="display: inline-block;width: 9.4%;padding: 0px;margin: 0px;margin-right: 0.6%;" v-if="index >= 60">
                <img :src="item" alt="" style="width: 100%;" class="div_img_h">
            </div>
        </div>
    </div>
    <!-- part2 -->
    <div style="background-color: rgb(247, 247, 249);padding: 32px 0px;">
        <div style="width: 100%; padding-bottom: 32px">
            <div style="text-align: center;font-size: 24px;color: #000;">全网站式服务</div>
            <div style="text-align: center;font-size: 16px;color: #4B4B4B;margin-top: 10px;">一号互通拥有多种端口软件服务</div>
        </div>
        <div class="color_box">
            <div class="color_box1"></div>
            <div class="color_box2"></div>
            <div class="color_box3"></div>
        </div>
        <div class="site_text">
            <div>APP</div>
            <div style="margin-left: 88px;">小程序</div>
            <div style="margin-left: 86px;">WEB</div>
            </div>
            <div class="site_box">
            <div class="app_box" style="margin-right: 104px;">
                <div class="app_img">
                <img src="../../static/img/1.png" alt />
                </div>
                <div class="app_title">APP</div>
                <div class="app_text">
                员工手机管理顾客、预约顾客，增加<br>与客户的黏性；老板可通过APP<br>随时查看门店的业绩，方便<br>调整经营策略
                </div>
            </div>
            <div class="app_box" style="margin-right: 104px;">
                <div class="app_img">
                <img src="../../static/img/2.png" alt />
                </div>
                <div class="app_title">小程序</div>
                <div class="app_text">
                用户数量持续增长，市场空间巨大；<br> 快速裂变分销，快速拓展销售<br>渠道，促进业绩增长
                </div>
            </div>
            <div class="app_box">
                <div class="app_img">
                <img src="../../static/img/3.png" alt />
                </div>
                <div class="app_title">WEB</div>
                <div class="app_text">
                实现电脑收银；系统化管理顾客档<br>案，精准分析顾客；品项分析，<br>将品项利润最大化；门店数<br>据实时生成、分析，增长业绩
                </div>
            </div>
        </div>
    </div>
    <!-- 大背景图 -->
    <div class="big_img">
      <div class="big_text">性能强大、安全、稳定的 SaaS 产品</div>
      <div class="big_text2">系统稳定高于一切，让门店经营有保障，门店管理更省心</div>
      <div style="margin:0 auto;display: flex;align-items: center;padding-top: 70px;width: 1200px;justify-content: space-between;">
        <div class="box1">
          <div class="box2">
            <img src="../../static/img/home/4.png" alt />
          </div>
          <div class="box3">
            <div style="color: #000;">护航门店稳定</div>
            <div style="color: #969FB1;margin-top: 8px;">系统化的管理</div>
          </div>
        </div>
        <div class="box1" >
          <div class="box2">
            <img src="../../static/img/home/5.png" alt />
          </div>
          <div class="box3">
            <div style="color: #000;">护航数据安全</div>
            <div style="color: #969FB1;margin-top: 8px;">基于阿里云服务器</div>
          </div>
        </div>
        <div class="box1" >
          <div class="box2">
            <img src="../../static/img/home/6.png" alt />
          </div>
          <div class="box3">
            <div style="color: #000;">护航消费者体验</div>
            <div style="color: #969FB1;margin-top: 8px;">操作简单</div>
          </div>
        </div>
        <div class="box1">
          <div class="box2">
            <img src="../../static/img/home/7.png" alt />
          </div>
          <div  class="box3">
            <div style="color: #000;">护航页面打开速度</div>
            <div style="color: #969FB1;margin-top: 8px;">页面打开速度仅需1秒</div>
          </div>
        </div>
      </div>
      <div style="width: 1200px;margin: 0 auto;">
        <el-button type="primary" size="small" style="margin:0 auto;margin-top: 80px;width: 132px;margin-left: 540px;">了解更多</el-button>
      </div>
    </div>
    <div class="partone_bg">
        <div style="width: 100%; padding-top: 48px; padding-bottom: 42px">
            <div style="text-align: center;font-size: 24px;color: #000;">美服在线合作案例</div>
            <div style="text-align: center;font-size: 16px;color: #4B4B4B;margin-top: 10px;">客户的支持信赖成就了我们今天的辉煌</div>
        </div>
        <div style="width:1660px;height: 304px;overflow: hidden;margin: 0 auto;margin-top: 72px;">
          <el-carousel>
            <el-carousel-item>
                <div style="height:304px;">
                    <div class="zm1" v-for="(item, index) in array_case" :key="index" :style="{'margin-left':index == 0 ? '0px' : '20px'}" v-if="index < 7">
                        <div class="zm2">
                            <div class="zm2-1"><img :src="item.img_icon" alt="" style="width: 100%;height: 100%;border-radius:50%"></div>
                        </div>
                        <div class="zm3">
                            <div class="zm4"></div>
                            <div class="zm5">
                                <div class="zm5-1">{{item.name}}</div>
                                <div class="zm5-2" style="padding-top:5px;font-size:12px;color:#7a7a7a;line-height:25px">{{item.content}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item>
                <div style="height:304px;">
                    <div class="zm1" v-for="(item, index) in array_case" :key="index" :style="{'margin-left':index == 7 ? '0px' : '20px'}" v-if="index >= 7">
                        <div class="zm2">
                            <div class="zm2-1"><img :src="item.img_icon" alt="" style="width: 100%;height: 100%;border-radius:50%"></div>
                        </div>
                        <div class="zm3">
                            <div class="zm4"></div>
                            <div class="zm5">
                                <div class="zm5-1">{{item.name}}</div>
                                <div class="zm5-2" style="padding-top:5px;font-size:12px;color:#7a7a7a;line-height:25px">{{item.content}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-carousel-item>
          </el-carousel>
        </div>
       
      </div>
    <!-- 合作伙伴 -->
    <div style="width:100%;background:rgba(248,249,253,1);min-width: 1550px;padding-bottom: 32px;">
        <div style="margin: 0px 32px;">
            <div v-for="(item, index) in img_logo_img_array" :key="index" style="display: inline-block;width: 3.7%;margin-left: 8px;">
                <img :src="item" alt="" style="width: 100%;height: 100%;" class="div_img_h">
            </div>
        </div>
    </div>
    <!-- 适用行业   支持多种行业场景使用 -->
    <div style="width: 100%;">
        <div style="text-align: center;font-size: 28px;color: #000;margin-top: 56px;">适用行业场景</div>
        <div style="text-align: center;font-size: 18px;color: #4B4B4B;margin-top: 7px;">
            立足美丽生活，系统化管理店里的员工以及顾客，让管理更加轻松应对
        </div>
        <div class="color_box">
            <div class="color_box1"></div>
            <div class="color_box2"></div>
            <div class="color_box3"></div>
        </div>
        <div style="padding: 2% 5%;">
            <div v-for="(item, index) in arrayFive" :key="index" style="width: 22%;background-color: white;display: inline-block;margin-left: 30px;box-shadow: 0px 0px 24px 10px rgba(219, 219, 219, 0.5);margin-bottom: 30px;">
                <div style="text-align: center;padding: 10px 0px;">{{item.name}}</div>
                <div style="padding: 0px 20px 15px 20px;">
                    <img :src="item.img" style="width: 100%;" alt="">
                </div>

            </div>
        </div>
    </div>
    <!-- 关于美服在线 -->
    <div style="padding-bottom: 20px;width: 100%;">
        <div style="width: 100%; padding-top: 48px; padding-bottom: 32px">
            <div style="text-align: center;font-size: 24px;color: #000;">关于美服在线</div>
            <div style="text-align: center;font-size: 16px;color: #4B4B4B;margin-top: 10px;">一号互通拥有多种端口软件服务</div>
        </div>
      <div class="color_box">
        <div class="color_box1"></div>
        <div class="color_box2"></div>
        <div class="color_box3"></div>
      </div>
      <div class="videos">
        <video src="https://yuyunrj.oss-cn-shenzhen.aliyuncs.com/video/zhaomeiw2020_product.mp4"
          style="width: 718px;height: 472px;object-fit: fill;" controls="controls" muted></video>
        <div style="width: 482px;height: 534px;background: #fff;box-shadow:0px 0px 60px 10px rgba(13,37,62,0.1);">
          <div class="company_title">公司简介</div>
          <div class="company_text">
            美服在线（原“御韵软件”）: 致力于美业发展，拥有落地的美业SaaS云服务系统，专业的美业产业链综合性平台；为美业供应商、店家、终端顾客提供智能化解决方案，
            真正将美业“上、中、下游”形成产业闭环，帮店家管好店，助厂商找到店。
          </div>
        </div>
      </div>
    </div>
    
    <!-- 尾部 -->
    <RMBottomDiv></RMBottomDiv>
    <el-dialog title="" :visible.sync="centerDialogVisible" width="1100px" center :modal-append-to-body="false" class="login_dialog" :show-close="false" :modal="false">
        <div style="width: 100%;height: 686px;background-color: white;box-shadow: 0px 0px 16px 16px rgba(0, 0, 0, 0.2);padding: 14px;position: relative;margin-top: -40px;">
            <div style="overflow: hidden;width: 100%;height: 100%;">
                <img class="img_class" :src="showModel.img_name" alt="" style="width: 100%;height: 100%;">
            </div>
            <el-row type="flex" align="middle" style="position: absolute;width: 97.5%;height: 96.2%;;top: 14px;left: 14px;font-size: 14px;color: white;border-radius: 3px;background-color: rgba(0, 0, 0, 0.5);">
                <el-col>
                    <div>
                        <div style="border-radius: 50%;width: 80px;height: 80px;background-color: rgb(255, 255, 255,0.1);margin-left: 210px;">
                            <img :src="showModel.icon_name" alt="" style="border-radius: 50%;width: 60px;height: 60px;margin-left: 10px;margin-top: 10px;">
                        </div>
                    </div>
                    <div style="text-align: center;margin-top: 15px;font-size: 18px">{{showModel.name}}</div>
                    <div style="text-align: center;margin-top: 10px;">（{{showModel.address}}）</div>
                    <div style="text-align: center;margin-top: 10px;">门店数：{{showModel.number}}</div>
                    
                    <div style="text-align: center;margin-top: 10px;">{{showModel.title_text}}</div>
                    <div style="margin-top: 30px;">
                        <img :src="showModel.img_name" alt="" style="width: 400px;height: 200px;margin-left: 10%;">
                    </div>
                </el-col>
                <el-col :span="3">
                    <div style="border-right:1px dashed #ccc; height:600px; width:1px;"></div>
                </el-col>
                <el-col>
                    <div v-for="(model,index) in showModel.content":key="index" style="white-space: pre-line;line-height: 27px;margin-top: 25px;padding-right: 50px">{{model}}</div>
                </el-col>
            </el-row>
        </div>
    </el-dialog>
  </div>

</template>

<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
    import RMBottomDiv from '../../src/page/RMBottomDiv.vue';
  import navs from "../components/common/nav";
  import { mapMutations } from "vuex";
  import * as commonApi from "api/common";
  export default {
    props: {},
    components: { navs, RMTopDiv,RMBottomDiv},
    data() {
      return {
        number_value:7.2,
        centerDialogVisible:false,
        array_case:[
              {
                  "name":"一生美",
                  "img_icon":require("../../static/img/YsmLOGO.png"),
                  "content":"以“新娘美容”为核心，延伸至孕妇和婴幼儿的护肤保养，帮助千千万万爱美女性实现“天然护肤，美丽蝶变”的梦想。"
              },
              {
                "name":"雅红美容",
                "img_icon":require("../../static/img/YhLOGO.png"),
                "content":"主营美容、美体、生物抗衰、高端养生、完美身材管理等，一直以“给予美，收获爱”的理念，致力于打造女性健康、美丽、高品质生活的平台。"
              },
              {
                "name":"御玫瑰健康美肤",
                "img_icon":require("../../static/img/YmgLOGO.png"),
                "content":"一家集美容护肤、经络养生、教育培训为一体的全国直营美容连锁机构，一直秉持 “做好每一次手法，服务好每一个客户”的经营理念。"
              },
              {
                "name":"韵婴妈妈",
                "img_icon":require("../../static/img/YymmLOGO.png"),
                "content":"一家集产后恢复、母乳喂养、亲子水育、小儿推拿、产品与系统开发，打造五维一体综合型的母婴护理连锁机构伴。"
              },
              {
                "name":"行·SPA",
                "img_icon":require("../../static/img/XspaLOGO.png"),
                "content":"从创立起只与国内顶尖企业合作，引进行业顶尖项目，为客户的健康美丽保驾护航，秉承实现客户美丽蜕变，传播健康养生理念的初心！"
              },
              {
                "name":"康缇雅",
                "img_icon":require("../../static/img/KtyLOGO.png"),
                "content":"拥有优质的化妆品联盟平台，莱蔓诗化妆品有限公司、莱蔓诗商学院、莱蔓诗有机农场、集研发生产销售一体化。"
              },
              {
                "name":"女主角国际美容连锁",
                "img_icon":require("../../static/img/NzjLOGO.png"),
                "content":"集整形、护肤、纤体、养生、教育于一体的大型专业美业服务连锁企业。"
              },
              {
                "name":"爱美空间",
                "img_icon":require("../../static/img/AmkjLOGO.png"),
                "content":"专注于中医养生，为提升客户的健康水平不懈努力，提供一流的服务、合理的价格、优质的品牌形象与时尚感。"
              },
              {
                  "name":"岸芷汀兰",
                  "img_icon":require("../../static/img/shop_img_icon/anzhidinglan_icon.png"),
                  "content":"岸芷汀兰成立于2009年，到现在已经有10个年头了，岸芷汀兰是义薄云天集团旗下的直营连锁品牌之一。"
              },
              {
                  "name":"欧赛媤",
                  "img_icon":require("../../static/img/shop_img_icon/ousaisi_icon.png"),
                  "content":"山东OASIS欧赛媤美容服务有限公司，是集美容直营店、商学院教育、美业平台运营管理为一体的集团公司。"
              },
              {
                  "name":"珍妮优",
                  "img_icon":require("../../static/img/shop_img_icon/zengniyou_icon.png"),
                  "content":"北京珍妮优健康美容为女性提供专业的多元化美容美体服务。"
              },
              {
                  "name":"路伊威莎",
                  "img_icon":require("../../static/img/shop_img_icon/luyinweisha_icon.png"),
                  "content":"以推广中国式美容自由连锁为主，集连锁发展，美容教育，产品研发、美容服务、美容咨询、美容商贸为一体的女性奢华消费品的亚洲公司。"
              },
              {
                  "name":"丽颜国际",
                  "img_icon":require("../../static/img/shop_img_icon/nishikong_icon.png"),
                  "content":"丽妍国际美业集团是一家集直营连锁、集团下属机构有：直营美容养生会所（60余家）、产品中心、医美抗衰公司、光电公司。实现健康与美丽并存的梦想，释放女性无限魅力。"
              },
              {
                  "name":"美之露",
                  "img_icon":require("../../static/img/shop_img_icon/meizhilu_icon.png"),
                  "content":"美之露美容集团，是一家大型的现代女性专业美容连锁机构。现已成为东莞市直营门店和会员人数分布广泛的美容连锁品牌之一，拥有二十多家直营店，并在全国范围内设立了上百家加盟机构。"
              }
          ],
        arrayOne:[
            {
                "name":"晴美国际",
                "number":"15家",
                "address":"广东·肇庆",
                "title_text":"品牌slogan:传播美丽·传播爱",
                "img_name":require("../../static/img/shop_img/qingmei.png"),
                "icon_name":require("../../static/img/shop_img_icon/qingmei_icon.png"),
                "content":[
                    "品牌简介:",
                    "晴美国际创办于1993年在广州番禺成立了第一家美容会所，距今已有27年的美容经验累积，企业并于2017年成立其姐妹品牌晴美·菩美阁，主要辐射肇庆端州、鼎湖、高要、云浮、新兴、四会、金利等区域的直营美容连锁企业。\n晴美·菩美阁传承金刚智慧的文化，用专业来滋养、用文化来薰陶净化我们的身心，明心见性、乐天知命是晴美·菩美阁倡导的大智慧，阴阳平衡天人合一是金刚智慧能达到的大境界。在晴美·菩美阁，您可充分体验、感悟禅文化，学习香道、修行瑜伽、沉入冥想。",
                    "晴美·菩美阁专注修身，集美容、养生、养骨、香养为一体；重视修心，用瑜伽、冥想帮助人们追寻幸福密码，实现心湖平静；追求修灵，积极组织公益慈善活动，不断回馈社会，用爱播下幸福的种子。晴美·菩美阁，全方位呵护您的身、心、灵健康，让您静享岁月之美好。",
                    "晴美·菩美阁，静心呵护您的美！"
                ],
            },
            {
                "name":"雅红",
                "number":"10家",
                "title_text":"",
                "address":"广东·佛山",
                "img_name":require("../../static/img/shop_img/yahong.png"),
                "icon_name":require("../../static/img/shop_img_icon/yahong_icon.png"),
                "content":[
                    "品牌简介:",
                    "雅红美容连锁成立于2004年，在佛山顺德己成立15年，目前在顺德北滘、伦教、碧江、陈村、龙江有九家连锁店，主营美容、美体、生物抗衰、高端养生、身材管理等，还有两家公司，一所商学院，在连州还有一个近20亩的绿色生态农场。",
                    "司一直以“给予美，收获爱”的理念致力于打造一个让女性朋友过上健康、美丽、高品质生活的平台。公司坚持用“诚信经营、关爱感恩”的经营理念为团队搭建了一个实现梦想的舞台，创始人庄欣女士提倡关爱感恩从身边人做起，让团队成员通过自己的努力不断提升自我，实现人生价值。"
                ]
            },
            {
                "name":"伊朵娜",
                "number":"10家",
                "title_text":"",
                "address":"广东·广州",
                "img_name":require("../../static/img/shop_img/yiduona.png"),
                "icon_name":require("../../static/img/shop_img_icon/yiduona_icon.png"),
                "content":[
                    "品牌简介:",
                    "伊朵娜国际美容美体连锁机构是一家专门致力于女性美容美体的大型连锁店，以“创造健康与美丽，传播爱心与欢乐”使命与信念，以专业成就女性健康，美丽快乐为经营宗旨，热心、真心、用心、尽心、专心面对每一位顾客，全体员工真诚的欢迎您的光临！"
                ]
            },
            {
                "name":"韵婴妈妈",
                "number":"22家",
                "title_text":"",
                "address":"广东·惠州",
                "img_name":require("../../static/img/shop_img/yunyingmima.png"),
                "icon_name":require("../../static/img/shop_img_icon/yunyingmama_icon.png"),
                "content":[
                    "品牌简介:",
                    "华韵集团是一家集产后恢复、母乳喂养、亲子水育、小儿推拿、招生培训为核心业务，通过产品技术与系统开发打造的五维一体综合型母婴护理一体化产业生态闭环企业。集团旗下拥有韵婴妈妈、韵婴贝贝、葆韵堂多个品牌，并与多家业内龙头企业及研发性基地达成战略性合作伙伴，专攻备孕、孕期、小产综合等女性孕产健康解决方案。",
                    "华韵集团成立于2012年，总部位于有深圳后花园之称的美丽城市——惠州，集团历经八年的研发、运营与管理，已经成为广东地区“全周期母婴健康管理”行业中的先导者，并相继在广州、深圳、东莞、惠州等地区，服务累计超万产后女性及十万余名婴幼儿。",
                    "华韵集团以市场需求为导向，引进先进的产后恢复仪器，结合传统方法，以高水平专家服务团队，根据每一位妈妈体质的不同而量身定制产后恢复计划，具有针对性强、安全健康、效果显著等特点，让更多的产后妈妈恢复了美丽与自信！",
                    " 华韵集团狠抓内部全面质量管理，加强集团整体的知名度、美誉度的宣传和人才的引进，并定期开展母婴健康公益活动，推动中国孕、产、哺、育迈向国际化。华韵集团通过一系列运作，承担着华韵集团作为行业领头羊的社会责任，进行品牌化建设！"
                ]
            },
            {
                "name":"玲珑梵宫",
                "number":"150家",
                "title_text":"",
                "address":"江西·南昌",
                "img_name":require("../../static/img/shop_img/linglongfangong.png"),
                "icon_name":require("../../static/img/shop_img_icon/linglongfangong_icon.png"),
                "content":[
                    "品牌简介:",
                    "玲珑梵宫成立于2006年，是一家集美容、教学、科研、医疗为一体的综合健康科技产业。总部设立于江西，“玲珑梵宫”强调内外兼修，系统调养，现已形成美容、养生、美业教学、专业会展等领域综合服务流通产业。",
                    ]
            },
            {
                "name":"岸芷汀兰",
                "number":"200家",
                "title_text":"",
                "address":"浙江·杭州",
                "img_name":require("../../static/img/shop_img/anzhidinglan.png"),
                "icon_name":require("../../static/img/shop_img_icon/anzhidinglan_icon.png"),
                "content":[
                    "品牌简介:",
                    "岸芷汀兰成立于2009年，到现在已经有10个年头了，岸芷汀兰是义薄云天集团旗下的直营连锁品牌之一。集团公司在全国有180多家直营门店。"
                ]
            },
            {
                "name":"欧赛媤",
                "number":"120家",
                "title_text":"",
                "address":"山东·淄博",
                "img_name":require("../../static/img/shop_img/ousaisi.png"),
                "icon_name":require("../../static/img/shop_img_icon/ousaisi_icon.png"),
                "content":[
                    "品牌简介:",
                    "OASIS——沙漠中的绿洲，在错综复杂的社会环境中实现人生梦想的一片净土;",
                    "一个打造女性魅力，实现人生价值的美丽科技创新服务平台;",
                    "OASIS欧赛媤始终坚持“成就别人，成就自己”的企业理念，向天下传播美丽健康之道，OASIS深谙东方女性美丽健康特点，使用适合东方女性美丽健康的产品，结合OASIS 通过中医、西医女性美丽健康学研发的独树一帜的医学背景《精准美丽科学服务体系》，国际前沿的先进设备，为顾客提供精准、安全的美丽健康服务。",
                    "OASIS欧赛媤以绽放员工、美丽顾客的企业宗旨，始终秉承科学技术是第一生产力，更是生命线的服务原则，通过不断的学习与创新，让团队专业技术与服务不断提升，不断成长，来赢得广大消费者的信任，来实现我们的团队梦想，现已从最初的18人创业发展到1000人团队梦想的实现。",
                    "OASIS欧赛媤通过多年美丽服务行业经验，结合世界美业未来发展方向，倾力打造适合行业发展的顾客服务标准规范、店务运营标准规范、加盟体系标准规范、产品技术标准规范等规范化标准体系，让顾客满意，让团队成长，让合作伙伴可持续发展，打通美业品牌发展新路线，实现绿色美业共赢。"
                ]
            },
            {
                "name":"珍妮优",
                "number":"13家",
                "title_text":"",
                "address":"中国·北京",
                "img_name":require("../../static/img/shop_img/zengniyou.png"),
                "icon_name":require("../../static/img/shop_img_icon/zengniyou_icon.png"),
                "content":[
                    "品牌简介:",
                    "北京珍妮优健康美容为女性提供专业的多元化美容美体服务。秉承先进的健康美容养生理念，通过安全有效的技术与产品及专业的手法，帮助顾客身心灵全方位放松，让顾客在极致享受中，焕发青春光彩。"
                ]
            },
            {
                "name":"聚尚",
                "number":"8家",
                "title_text":"",
                "address":"广东·广州",
                "img_name":require("../../static/img/shop_img/jusang.png"),
                "icon_name":require("../../static/img/shop_img_icon/jusang_icon.png"),
                "content":[
                    "品牌简介:",
                    "聚尚护肤造型是集美容SPA、美发设计、美体塑身、健康养生为一体的高端美容美发品牌"
                ]
            },
            {
                "name":"海棠集团",
                "number":"13家",
                "title_text":"",
                "address":"中国·上海",
                "img_name":require("../../static/img/shop_img/haitang.png"),
                "icon_name":require("../../static/img/shop_img_icon/haitang_icon.png"),
                "content":[
                    "品牌简介:",
                    "秋雨海棠——新一代健康美容品牌，专注健康养生和专业美容美体服务及产品。结合国际先进美容知识理念和中国传统美容养生精髓，帮助您呈现由内而外、自然而生的美丽形象。提升美的品位，成就美的梦想！感谢您关注秋雨海棠美容养生连锁机构公众平台，优先享受国际潮流项目服务，掌握一手优惠信息。"
                ]
            },
            {
                "name":"名太",
                "number":"10家",
                "title_text":"",
                "address":"广东·广州",
                "img_name":require("../../static/img/shop_img/mingtai.png"),
                "icon_name":require("../../static/img/shop_img_icon/mingtai_icon.png"),
                "content":[
                    "品牌简介:",
                    "专注女士美容、养生、美胸、减肥、纹绣15年"
                ]
            },
            {
                "name":"女主角",
                "number":"10家",
                "title_text":"",
                "address":"广东·东莞",
                "img_name":require("../../static/img/shop_img/nvzhujue.png"),
                "icon_name":require("../../static/img/shop_img_icon/nvzhujue_icon.png"),
                "content":[
                    "品牌简介:",
                    "女主角（国际）美容养生连锁集团成立于2001年，这是一个温暖和谐的大家庭，拥有一支热情洋溢、活力四射的专业团队。集团在董事长车素君女士的带领下，树立人性化的管理，独特的经营理念，专业优质的服务，完善的配套设施，已发展为美容行业的佼佼者。目前集团拥有东莞直营店8间，山西直营店2间，千年虹美妆教育学校一所，君熠医疗美容诊所一所，优雅女子学堂一所，集护肤、纤体、养生、医疗美容、教育于一体。集团始终坚持以品牌为生命，以文化为灵魂，以诚信为价值，以服务为根本，女主角以至真至诚的服务，回应健康与美丽的需求，立志打造一颗最璀璨的美业明星。"
                ]
            },
            {
                "name":"宴遇美胸",
                "number":"13家",
                "title_text":"",
                "address":"广东·东莞",
                "img_name":require("../../static/img/shop_img/yanyu.png"),
                "icon_name":require("../../static/img/shop_img_icon/yanyu_icon.png"),
                "content":[
                    "品牌简介:",
                    "东莞宴遇美胸会所是皇莎国际旗下的高端会所，皇莎国际集团是一家以健康产业为主的多元化发展集团企业；辐射地区跨越中国、台湾、德国、日本、新加坡、香港、法国、英国等，其业务范围涉及房地产、珠宝、连锁教育、咨询管理，网络科技开发、整形连锁、疤痕修复连锁、科技美肌连锁、美胸连锁等多个品牌实体连锁为女性提供一站式的健康美丽解决方案，并凭借着多年积累涉猎投资贸易、产品研发和项目开发等17项跨界项目。"
                ]
            },
            {
                "name":"行·SPA",
                "number":"13家",
                "title_text":"",
                "address":"广东·广州",
                "img_name":require("../../static/img/shop_img/xingspa.png"),
                "icon_name":require("../../static/img/shop_img_icon/xingspa_icon.png"),
                "content":[
                    "品牌简介:",
                    "行 · SPA,一个充满梦想和活力的企业！立志打造广州高端社区精品美容养生会所第一品牌！",
                    "行 · SPA人坚持以成人达己的共赢理念为标准，来回报客户们一直以来对行 · SPA的信任与厚爱！感受会员朋友们的一路支持，替我们口碑宣传，是您们的一路陪伴，成就了今生生机勃勃的行 · SPA！",
                    "未来，行·SPA人将继续以饱满诚挚的热情，高品质的优质服务为基础，为会员朋友们带来更多尊贵感受和体验！让会员朋友们达到身心灵的健康与美丽！"
                ]
            },
            {
                "name":"雅馨安娜",
                "number":"11家",
                "title_text":"",
                "address":"广东·广州",
                "img_name":require("../../static/img/shop_img/yaxinanna.png"),
                "icon_name":require("../../static/img/shop_img_icon/yaxinanna_icon.png"),
                "content":[
                    "品牌简介:",
                    "雅馨安娜是一家美容护肤为一体的连锁店面。"
                ]
            },
            {
                "name":"臻钰",
                "number":"13家",
                "title_text":"",
                "address":"广东·广州",
                "img_name":require("../../static/img/shop_img/zhenyu.png"),
                "icon_name":require("../../static/img/shop_img_icon/zhenyu_icon.png"),
                "content":[
                    "品牌简介:",
                    "臻钰养容是一家已连续经营了16年的高端美容连锁机构，更是广东省美容美发协会常务理事单位。到目前为止拥有13家直营店，分布在广州市与佛山市。我们的愿景是成为中国美业社区连锁高端养容第一品牌；我们的使命是引领女性生活美。",
                    "荣誉是社会对企业良好经营的肯定与嘉奖，更是一个企业诚信运作得来的硕果。臻钰十几年诚信耕耘和开拓进取，至今获得的社会荣誉已经硕果累累。",
                    "发展至今，臻钰曾荣获的荣誉有：【CCTV影响力百家媒体联合推荐杰出美容会所】、【中国百强连锁美容院】、【广州亚运会优质服务示范门店】、【广州市巾帼创业示范基地】、【广州市海珠区创业和就业实训基地】、连续四年的【广东省守合同重信用企业】、【广东省美业最具影响力连锁机构】、【广东诚信经营美容店】、【广州年度消费者最信赖企业】等。"
                ]
            }
        ],
        arrayTwo:[
            {
                "name":"路伊威莎",
                "number":"14家",
                "title_text":"",
                "address":"四川·眉山",
                "img_name":require("../../static/img/shop_img/luyinweisha.png"),
                "icon_name":require("../../static/img/shop_img_icon/luyinweisha_icon.png"),
                "content":[
                    "品牌简介:",
                    "香港路伊威莎国际投资集团于2009年4月正式进入中国内地市场，为了适应中国美容行业的特色化、差异化、本土化，公司总部集连锁发展，营销策划，美容教育，产品研发为一体。在全国各地建立了多家连锁门店。经过长期发展，路伊威莎集团正式形成一条集美容养生连锁，化妆品销售等以女性消费为主的全新产业链。"
                ]
            },
            {
                "name":"爱美空间",
                "number":"26家",
                "title_text":"",
                "address":"广东·东莞",
                "img_name":require("../../static/img/shop_img/aimeikongjian.png"),
                "icon_name":require("../../static/img/shop_img_icon/aimeikongjian_icon.png"),
                "content":[
                    "品牌简介:",
                    "爱美空间美容连锁成立于2005年。多年来为顾客提供一流的服务、合理的价格、品牌的优质形象与时尚感。打造广东养生领先品牌。多年来我们不断的钻研中医养生，优化项目的技术以满足客户需求。为提升客户的健康水平不懈努力。"
                ]
            },
            {
                "name":"图澜朵",
                "number":"27家",
                "title_text":"",
                "address":"湖南·长沙",
                "img_name":require("../../static/img/shop_img/tulanduo.png"),
                "icon_name":require("../../static/img/shop_img_icon/tulanduo_icon.png"),
                "content":[
                    "品牌简介:",
                    "朵梵美容咨询有限公司是一家大型美容美体连锁机构，旗下有艾尚图澜朵、朵美时光、瑞SPA、瑞服饰、元瑞脑SP健康中心等品牌。包含生活美容、科技美容、医疗美容。"
                ]
            },
            {
                "name":"希蓓蒙",
                "number":"19家",
                "title_text":"",
                "address":"广东·广州",
                "img_name":require("../../static/img/shop_img/xibeimeng.png"),
                "icon_name":require("../../static/img/shop_img_icon/xibeimeng_icon.png"),
                "content":[
                    "品牌简介:",
                    "希蓓蒙国际美容连锁创办于2008年，是一家集直营连锁、产品研发、光电仪器、教育培训为一体的多元化美容连锁公司，旗下机构有：直营美容养生会所、产品中心、光电中心。我们用专业、高质、热忱做到让顾客满意；用文化和爱来培养员工成长；并积极参加社会公益活动，成为一家有一定社会影响力的企业。企业旗下美容连锁品牌，秉承“美丽容颜、健康生活、精彩人生”的品牌宗旨，为消费者提供安全、优质的高端护肤品，自然、绿色的身体调理及专业细致的个人美容护理定制服务，帮助女性健康护理肌肤、自然调理身体，实现健康与美丽并存的梦想，释放女性无限魅力！"
                ]
            },
            {
                "name":"御玫瑰",
                "number":"54家",
                "title_text":"",
                "address":"广东·广州",
                "img_name":require("../../static/img/shop_img/yumeigui.png"),
                "icon_name":require("../../static/img/shop_img_icon/yumeigui_icon.png"),
                "content":[
                    "品牌简介:",
                    "一家集美容护肤、经络养生、教育培训为一体的全国直营美容连锁机构，一直秉持 “做好每一次手法，服务好每一个客户”的经营理念。"
                ]
            },
            {
                "name":"肤儿美",
                "number":"400家",
                "title_text":"",
                "address":"广东·广州",
                "img_name":require("../../static/img/shop_img/fuermei.png"),
                "icon_name":require("../../static/img/shop_img_icon/fuermei_icon.png"),
                "content":[
                    "品牌简介:",
                    "1998肤儿美第一家直营连锁店正式营业，历经十二年的发展，2010年正式成立了香港肤儿美连锁集团，从此开启了公司规范化运营和跨区域发展的新篇章。",
                    "香港肤儿美连锁集团拥有私人定制养生、私人定制面部护理、SPA、私密保养（性感训练营）、光电中心（优立塑、欧洲之星、皮秒、纳米精雕等等）、生态教育、连锁复制九大皇牌系统。截至今日，香港肤儿美连锁集团直营美容连锁店，遍布珠三角广州、佛山、深圳、珠海、韶关、清远、东莞、河源等，并辐射至全国北京、四川、湖南、江西、山西、江苏、福建、河南、海南等等省份。现已成为广东省最具规模、最为专业的美容直营连锁企业之一。",
                    "肤儿美用十八年的时间去塑造和完善了优秀的企业文化和一支出色的团队。肤儿美员工的稳定性超过了很多人的理解，其原因在于肤儿美营造了“家”的氛围，我们塑造了团结融治，互助协作，拼搏奋进，开拓创新，海纳百川的肤儿美文化。 ",
                    "十八年来，肤儿美人倾情演绎“丑小鸭”蜕变“白天鹅”的神话传奇：近千家连锁直营联盟店被业界誉为“连锁奇迹·美业传奇”！风华十八载，万千姿彩！",
                    "伟大的目标成就伟大的心，肤儿美怀着对美丽、健康、财富的深邃感悟，用卓越的目光审视世界，将不倦的足迹跨越国际。"

                ]
            },
            {
                "name":"阳光新贵",
                "number":"50家",
                "title_text":"",
                "address":"广东·深圳",
                "img_name":require("../../static/img/shop_img/yangguangxingui.png"),
                "icon_name":require("../../static/img/shop_img_icon/yangguangxingui_icon.png"),
                "content":[
                    "品牌简介:",
                    "阳光新贵健康产业集团旗下有阳光美媛美容仟体连锁机构，阳光新贵美容美发连锁机构、香港纤美金雕美容科技集团，阳光新贵智和美业商学院，深圳经典美容美发培训学校等多家美业实体公司，公司在产品、培训、直营、加盟、整店输出等各个方面都有科学的运行系统，是深圳市美容美发养生行业知名的领军连锁企业 ",
                    "阳光新贵在深圳现已有23家直营店,二十多家加盟店，而且还在开设新的分店。总部综合办公室2000多平米，总经营面积5000多平米。",
                    "直营美容美发店分布于福田区、罗湖区、南山区、龙华区等区域。全国产品项目及经营模式加盟店有深圳，佛山，惠州，东莞，安徽，福建，大连等区域市场。"
                ]
            },
            {
                "name":"逆时空",
                "number":"25家",
                "title_text":"",
                "address":"吉林·长春",
                "img_name":require("../../static/img/shop_img/nishikong.png"),
                "icon_name":require("../../static/img/shop_img_icon/nishikong_icon.png"),
                "content":[
                    "品牌简介:",
                    "逆时空美容连锁始创于2013年，现已有二十余家直营店，是一家集专业、品质、服务为一体的美容养生会所。"
                ]
            },
            {
                "name":"美梦成真",
                "number":"28家",
                "title_text":"",
                "address":"中国·浙江",
                "img_name":require("../../static/img/shop_img/meimengchengzhen.png"),//meimengchengzhen
                "icon_name":require("../../static/img/shop_img_icon/meimengchengzhen_icon.png"),//meimengchengzhen_icon
                "content":[
                    "品牌简介:",
                    "美梦成真健康美容养生联锁作为台州美容养生的领军企业，一直秉乘顾客需求为导向，服务至上的理念，内外兼修，打造一个人人幸福开心的美业平台。美梦成真至2001年开始已有20年专注于美业发展历史，把个人目标梦想和美梦成真战略发展统一起来，打造幸福的家庭文化、社会公益文化、培训成长文化、健康运动文化.......让我们的顾客感受到高度的专业性，感受到我们发自内心的幸福和微笑。让我们一起成为追梦天使，一起美梦成真。"
                ]
            },
            {
                "name":"柏悦",
                "number":"20家",
                "title_text":"",
                "address":"广东·广州",
                "img_name":require("../../static/img/shop_img/boyue.png"),
                "icon_name":require("../../static/img/shop_img_icon/boyue_icon.png"),
                "content":[
                    "品牌简介:",
                    "科技领创至美力量对于前沿尖端科技持久不衰的热情与渴望，逐渐让医学界相信，永恒极致之美绝非一件无足轻重的事情",
                    "柏悦·SPA始终坚持“科技领创至美力量”，因此在筹备之初，就依托勤操集团强大的资源背景与企业实力，与国内外知名美容科研机构展开合作，持续引进生物学、皮肤学、医学美容等领域的前沿成果及高科技仪器设备，用科技为高端女性打造一座对抗时间的健康堡垒！"
                ]
            },
            {
                "name":"圣姬名黛",
                "number":"15家",
                "title_text":"",
                "address":"辽宁·盘锦",
                "img_name":require("../../static/img/shop_img/shengjimingdai.png"),
                "icon_name":require("../../static/img/shop_img_icon/shengjimingdai_icon.png"),
                "content":[
                    "品牌简介:",
                    "圣姬名黛集合直营连锁、特许加盟、教育培训、模式输出、托管经营等关联业务，致力于打造一批平价奢华的店、影响一批美妆同业的人、培养一批热爱行业的员工、最终通过企业自身的努力，在做好自身规范的同时，带动行业的发展。"
                ]
            },
            {
                "name":"德理堂",
                "number":"20家",
                "title_text":"",
                "address":"江西·南昌",
                "img_name":require("../../static/img/shop_img/delitang.png"),
                "icon_name":require("../../static/img/shop_img_icon/delitang_icon.png"),
                "content":[
                    "品牌简介:",
                    "德理堂实业集团是全产业链商业模式，旗下有德鑫糸，德美系，德丰系，德华系。德理堂控股德美系德美中国是全国连锁体系，现在全国有上百家连锁店，主要分布在四座城市，德美江西南昌，德美广州，德美郑州，德美洛阳等等。"
                ]
            },
            {
                "name":"佰花方",
                "number":"9家",
                "title_text":"",
                "address":"中国·重庆",
                "img_name":require("../../static/img/shop_img/baihuafang.png"),
                "icon_name":require("../../static/img/shop_img_icon/baihuafang_icon.png"),
                "content":[
                    "品牌简介:",
                    "​​​​​​广州白云山敬修堂药业是广药集团下属的主要制药企业之一。（香港H股和上海A股大型上市公司）始创于1790年，（清乾隆五十五年）是国家商务部认定的“中华老字号”企业，并被评为“非物质文化遗产”。它以制药的标准生产佰花方护肤品，生产通过了国家GMP认证，并通过了澳大利亚TGA认证。",
                    "200多年前，清乾隆盛世。传有“花朵美颜祛斑方”，引后宫三千竞相争抢。清乾隆54年（公元1790），广州敬修堂创立。227多年的光辉荣耀里，曾有人这样总结敬修堂：一樽万花油，普济海内 众生。而敬修堂也凭借对珍惜花的独特研究傲立与业界，花卉成为广药与敬修堂研究所源源不断的灵感源泉。",
                    "21世纪，广药与敬修堂研究所承继研创古老的“花朵美颜祛斑方”，利用陷阱的现代科技，在原配方的基础上，不断创新，研发出具有祛斑及修护肌肤的专利成分“百花精粹复合物”，安全有效，卓效祛斑的同时，修护肌肤健康平衡机制，让肌肤具有不长斑的抗体，持久净白。"
                ]
            },
            {
                "name":"BQ美丽智慧",
                "name_two":"",
                "number":"12家",
                "title_text":"",
                "address":"中国·台湾",
                "img_name":require("../../static/img/shop_img/meilizhihui.png"),
                "icon_name":require("../../static/img/shop_img_icon/meilizhihui_icon.png"),
                "content":[
                    "品牌简介:",
                    "拥有最强团队，再教育，行销，视觉设计，课程，商品都是顶尖+事业。解决问题肌肤，连医美诊所的医生都指定Ckeys.THALISSI来自西班牙无污染的覆地配方，改善形体，拥有抗老化的独特配方成立于2006年，专营医美保养品进出口OEM，ODM，治理引进国内外医学美容产品与设备，并引进欧美多家保养品进入国内市场。"
                ]
            },
            {
                "name":"春天百合",
                "name_two":"",
                "number":"7家",
                "title_text":"",
                "address":"广东·惠州",
                "img_name":require("../../static/img/shop_img/chuntianbaihe.png"),
                "icon_name":require("../../static/img/shop_img_icon/chuntianbaihe_icon.png"),
                "content":[
                    "品牌简介:",
                    "惠州市春天百合美容连锁机构创建于2007年10月，从最初一家美容院，到如今惠州最大的知名美容连锁机构，春天百合拥有7家店铺面积达200-400m²的直营店，集专业纤体、美颜、抗衰、养生、汗蒸会所、美容职业培训、幼儿保健于一体；创始人程静女士始终坚持“经营女性健康、美丽、营造喜悦、幸福和谐家庭”的企业使命，秉承用心，专心，责任心，进取心，感恩之心的服务理念，用专业建立口碑，成就广东美容连锁机构知名品牌。",
                    "相信自己，相信团队，相信企业”，是每一个春天百合美业人的基本生存法则，他们满腔热枕、无私奉献，把温暖与爱心通过优质的服务和产品传递给每一位顾客，他们勤奋好学、乐观上进，将自己的心血和汗水凝聚在春天百合的信念当中：“热爱美、缔造美、传播美。”创百年老店，立美业楷模！"
                ]
            },
            {
                "name":"佐登妮丝",
                "name_two":"",
                "number":"13家",
                "title_text":"",
                "address":"广东·东莞",
                "img_name":require("../../static/img/shop_img/zuodengnisi.png"),
                "icon_name":require("../../static/img/shop_img_icon/zuodengnisi_icon.png"),
                "content":[
                    "品牌简介:",
                    "佐登妮丝来自宝岛台湾，始创于1989年，是一家集研发、生产、教育、美容服务、终端经营为一体的大型跨国美容企业。 一直以来，佐登妮丝人致力于寻找让女人更美丽的方法，秉承「领导品牌、航向未来」的精神和「诚实信赖，永续经营」的理念，为每一位客户创造一个高质感、低消费的舒适空间，每一位从业人员皆以最真诚的服务态度及工作热忱，坚持采取高效率的服务与独特的技术来领导品牌，让客户享有最尊荣的礼遇，已建立一个令客户放心、安心、贴心的品牌"
                ]
            }
        ],         
        div_center_model:{
            "name":"圣莉斯歌",
            "number":"3000家",
            "title_text":"",
            "address":"广东·深圳",
            "img_name":require("../../static/img/shop_img/shenglisige.png"),
            "icon_name":require("../../static/img/shop_img_icon/shenglisige_icon.png"),
            "content":[
                "品牌简介:",
                "香港圣莉斯歌集团，是一家集生物研发、美容养生、健康管理、高科技仪器、培训教育、影视传媒、连锁运营管理、金融投资、高端酒店管理、服装珠宝定制等多元化发展的集团公司。",
                "圣莉斯歌，联合盛世集团、盛世丽达、盛世商学院、恒康国际、中科生物科技、科腾医药科技、华师生命工程研究院、命运集团等大型企业，共同打造美业万店联盟共享平台；本着消费透明化、服务标准化、产品品质化以及共创、共享、共赢、共生的理念，实现事业共同体、财富共同体、命运共同体三维一体的全新美业生态圈。",
                "圣莉斯歌，整合国际国内资源，引进全球最先进的仪器设备、最高端的护理品牌、最权威的医学专家、最标准的服务流程、最高品质的私人订制，打造七星级的服务标准。",
                "圣莉斯歌，以独创的“三龄五养”特色文化，打造女性美丽蜕变、优雅高贵的私人空间；通过“五感六觉”营造一个充满高贵感、安全感、舒适感、愉悦感、幸福感的尊贵体验。“三龄五养”特色文化：减龄、冻龄、逆龄，养身、养心、养灵、养颜、养性，致力让天下女性享受“身心灵”最原始的美好，享受生命之花最极致的绚丽绽放，享受健康、美丽、自信、幸福的极致人生。"
            ]
        },
        array_center_top:[
        {
            "name":"丽妍国际",
            "number":"68家",
            "title_text":"",
            "address":"广东·深圳",
            "img_name":require("../../static/img/shop_img/liyanguoji.png"),
            "icon_name":require("../../static/img/shop_img_icon/nishikong_icon.png"),
            "content":[
                "品牌简介:",
                "丽妍国际美业集团是一家集直营连锁、集团下属机构有：直营美容养生会所、产品中心、医美抗衰公司、光电公司。我们用专业、高质、热忱做到顾客满意；用文化和爱去培养员工成长；并积极参加社会公益活动，成为有一定社会影响力的企业。",
                "旗下美容连锁品牌，秉承“美丽容颜、健康生活、精彩人生”的品牌宗旨，为消费者提供优质、安全的高端护肤品；帮助女生健康护理肌肤、自然调理身体，实现健康与美丽并存的梦想，释放女性无限魅力"
            ]
        },
        {
            "name":"美之露",
            "number":"30家",
            "title_text":"",
            "address":"广东·东莞",
            "img_name":require("../../static/img/shop_img/meizhilu.png"),
            "icon_name":require("../../static/img/shop_img_icon/meizhilu_icon.png"),
            "content":[
                "品牌简介:",
                "美之露美容集团，由叶小平女士创办于1998年，是一家大型的现代女性美容连锁机构。历经20年的发展，旗下有广东、成都和湖南三个大区，30多家美容门店。是行业内较早成为集健全的美容队伍、完善的美容设备、高品位美容环境于一体的新型女性美容机构。",
                "自成立以来，美之露就以服务女性、回报社会为使命，专心致力于女性美丽健康事业的发展。以人性化化的管理模式、家人式服务理念和服务品质，让“美之露”品牌倍受社会各界关注与信赖。在追求“美丽与健康”新价值的今天，美之露推导“内调+外护”的平衡美容新主张。美之露将传统理论和现代美容理念相结合，为都市女性提供健康调理新体验。获得了客户的认同和业内人士的良好赞誉。多次获“中国美业百佳·诚信名店”称号。"
            ]
        }
        ],
        array_center_bottom:[
        {
            "name":"可欣佳人",
            "number":"25家",
            "title_text":"",
            "address":"中国·重庆",
            "img_name":require("../../static/img/shop_img/kexinjiaren.png"),
            "icon_name":require("../../static/img/shop_img_icon/nishikong_icon.png"),
            "content":[
                "品牌简介:",
                "重庆可欣佳人集美容护肤、形象设计、美体塑身、SPA养生、足疗保健的连锁机构。\n旗下拥有可欣佳人商学院、可欣佳人拓客部事业部、可欣佳人足疗养生事业部、可欣佳人大健康医美事业部、可欣佳人直营事业部为一体的连锁企业。"
            ]
        },
        {
            "name":"康缇雅",
            "number":"20家",
            "title_text":"",
            "address":"广东·广州",
            "img_name":require("../../static/img/shop_img/kangtiya.png"),
            "icon_name":require("../../static/img/shop_img_icon/kangtiya_icon.png"),
            "content":[
                "品牌简介:",
                "康缇雅成立于2005年，目前旗下在广州有20家直营美容连锁店，分布广州，番禺，佛山，拥有自已的优质化妆品联盟平台，莱蔓诗化妆品有限公司，莱蔓诗商学院，莱蔓诗有机农场，集研发生产销售一体化，用好的产品和服务服务好我们的客户和员工，致力让每个女人过上高品质生活！",
                "公司总经理郭春艳女士于2002年毕业于广州中医院校，祖上为医学世家，四代中医相传，郭女士于2004年推广中医经络理疗，并推出了独家养身疗法郭大夫秘制中医营养理疗。养身效果显著，健康不反弹，深受广大爱美女士的欢迎 。康缇雅美容连锁机构分店分布广东各大城市，为上万名顾客提供优质服务，从单一店发展到现在连锁店，集中布点，统一经营管理。",
                "康缇雅是我们大家的，是每一个人的，我们工作辛苦并快乐着，在这里我们可以学到在学校里学不到的知识，我们领导教会我如何与人相处，相互帮助，让我们感觉很温暖，在公司又学到一技之长，在这里我们看到比我们成功的人还在拼命的努力工作，所以我们一定要把专业学好，把服务做好，我们心中都有个梦，帮助更多的家庭，让每个女人过上高品质生活。"
            ]
        },
        ],
        arrayFive:[
            {
                "name":"美容美肤",
                "img":require("../../static/img/home/001.png")
            },
            {
                "name":"美甲美睫",
                "img":require("../../static/img/home/002.png")
            },
            {
                "name":"美发造型",
                "img":require("../../static/img/home/003.png")
            },
            {
                "name":"医美整形",
                "img":require("../../static/img/home/004.png")
            },
            {
                "name":"养生会所",
                "img":require("../../static/img/home/005.png")
            },
            {
                "name":"教育机构",
                "img":require("../../static/img/home/006.png")
            },
            {
                "name":"餐饮管理",
                "img":require("../../static/img/home/007.png")
            },
            {
                "name":"健身会所",
                "img":require("../../static/img/home/008.png")
            }
        ],
        scroll: '',
        scroll100: true,
        scroll700: false,
        img_array:[],
        img_right_array:[],
        img_right_center_array:[],
        img_logo_img_array:[],
        showModel:{}
      };
    },
    created() { },
    watch: {
      scroll: function () {
        this.loadSroll();
      }
    },
    methods: {
    
        viewMore_click(item){//点击查看详情
            this.centerDialogVisible = true
            this.showModel = item
        },
  
      goToMore(){

      },
     
      dataScroll(event) {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop || event.target.scrollTop
      },
      loadSroll: function () {
        if (this.scroll <= 100) {
          this.scroll100 = true
        } else {
          this.scroll100 = false
        }
        if (this.scroll > 100) {
          this.scroll700 = true
        } else {
          this.scroll700 = false
        }
      },
    },
    mounted() {
      //获取高度
      window.addEventListener("scroll", this.dataScroll, true);
      for(var i = 1; i <= 90; i++){
          var url =require( "../../static/img/img_left_icon/" + i + ".png")
          this.img_array.push(url)
      }
      for(var i = 1; i <= 90; i++){
          if(i == 25 || i == 27 || i == 34 || i == 35  || i == 36  || i == 37 || i == 45 || i == 47 || i == 54 || i == 55  || i == 56  || i == 57){
            var url = ""
          }else{
            var url = require("../../static/img/img_right_icon/" + i + ".png")
          }        
        this.img_right_array.push(url)
      }

      for(var i = 1; i <=120; i++){
          var url = require("../../static/img/login_logo_img/" + "logo" + i + ".png")
          this.img_logo_img_array.push(url)
      }
    },
  };
</script>
<style>
</style>
<style scoped lang="scss">
  /* @import "../assets/css/them.scss"; */
  @import "../assets/css/mains.css";

  .login-box {
    width: 100%;
    height: 100%;
    position: fixed;
    background: #fff;
    overflow-y: auto;
  }

  .index_video {
    width: 100%;
    /* height: 100%; */
    /* object-fit: fill; */
    position: relative;
    top: 0;
    left: 0;
  }

  .container_box {
    z-index: 10;
    position: absolute;
    top: 50%;
    left: 0;
    color: #fff;
    font-size: 50px;
    text-align: center;
    width: 100%;
    min-width: 769px;
    font-family: myOpenSans, 'PingFang SC', 'Microsoft YaHei';
  }

  .bag_1 {
    /* min-width: 1800px; */
    width: 100%;
  }

  .img_1 {
    /* width: 524px;
    height: 600px; */
    overflow: hidden;
    position: relative;
  }

  .img_1 img:hover {
    transform: scale(1.05);
    transition: all 0.5s;
  }
  .big_title{
    font-size: 22px;color: #fff;position: absolute;left: 33px;bottom:54px;font-weight: 500;
  }
  .small_title{
    font-size: 18px;color: #fff;position: absolute;left: 33px;bottom:21px
  }
  .img_2 {
    width: 635px;
    height: 280px;
    overflow: hidden;
    position: relative;
  }

  .img_2 img:hover {
    transition: all 0.5s;
    transform: scale(1.05);
  }

  .partone_bg {
    /* background: #f8f8f8; */
    background-image: url('../../static/img/case.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    width: 100%;
    /* padding-top: 40px; */
    padding-bottom: 40px
  }

  .zm1 {
    width: 220px;
    height: 304px;
    border-radius: 8px;
    float: left;
  }

  .zm1:hover .zm2 .zm2-1 {
    width: 64px;
    height: 64px;
    margin: 0 auto;
    transition: 0.3s
  }

  .zm1:hover .zm4 {
    height: 30px;
    transition: 0.3s
  }

  .zm1:hover .zm5-1 {
    display: none
  }

  .zm2 {
    height: 40px;
    position: relative;
  }

  .zm2-1 {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    background: pink;
    border-radius: 50%;
    transition: 0.3s
  }

  .zm3 {
    width: 220px;
    height: 264px;
    background: #fff;
    border-radius: 8px
  }

  .zm4 {
    width: 200px;
    height: 60px;
    margin: 0 auto;
    transition: 0.3s
  }

  .zm5 {
    width: 200px;
    height: 160px;
    /* background:#f2f2f2; */
    overflow: hidden;
    margin: 0 auto;
    overflow-y: auto;
    margin-top: 20px;
  }

  /* 滚动条 */
  .zm5::-webkit-scrollbar {
    width: 1px;
    height: 1px;
    background: transparent;
  }

  .zm5::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 4px;
  }

  .zm5:hover::-webkit-scrollbar-thumb {
    background: hsla(0, 0%, 53%, 0.4);
  }

  .zm5:hover::-webkit-scrollbar-track {
    background: hsla(0, 0%, 53%, 0.1);
  }

  .zm5-1 {
    /* padding-top:5px; */
    color: #222;
    font-size: 16px;
    text-align: center;
    /* color: #222; */
    /* background-color: red; */
    /* margin-left: 5px; */
  }

  .zm5-2 {
    margin-top: 10px;
    margin:0 5px;
  }

  .partone_box {
    padding-top: 29px;
    height: 326px;
    margin: 0 auto;
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .img_container {
    height: 326px;
    width: 263px;
    background: #fff;
    overflow: hidden;
    position: relative;
  }

  .card {
    width: 263px;
    height: 326px;
    background: #fff;
    position: absolute;
    top: 163px;
  }

  .card_moive {
    position: relative;
    width: 100%;
    height: 100%;
    background: #fff;
  }

  .img_container:hover .card {
    margin-top: -163px;
    transition: all 0.3s linear;
  }

  .shop_img {
    width: 263px;
    height: 163px;
  }

  .shopname {
    position: absolute;
    top: 111px;
    left: 39px;
  }

  .img2_container {
    height: 263px;
    width: 263px;
    background: #fff;
    overflow: hidden;
    position: relative;
  }

  .card2 {
    width: 263px;
    height: 263px;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 223px;
    border-radius: 0px 0px 4px 4px;
  }

  .card2_moive {
    position: relative;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    border-radius: 4px;
  }

  /* .img2_container:hover .card2 {
    margin-top: -223px;
    transition: all 0.3s linear;
  } */

  .name {
    font-size: 16px;
    color: #fff;
    height: 40px;
    text-align: center;
    padding-top: 9px;
    letter-spacing: 1px;
  }

  .name_des {
    line-height: 30px;
    font-size: 16px;
    color: #fff;
    margin-left: 16px;
    margin-right: 16px;
    text-align: center;
    letter-spacing: 1px;
  }

  .site_box {
    /* margin-left: 16.88%; */
    height: 388.5px;
    padding-top: 64px;
    display: flex;
    align-items: center;
    width: 1274px;
    margin: 0 auto;
  }

  .site_text {
    display: flex;
    align-items: center;
    font-size: 28px;
    color: #000;
    padding-top: 49px;
    width: 376px;
    margin: 0 auto;
  }

  .app_box {
    height: 388.5px;
    width: 355px;
  }

  .app_img {
    width: 172.5px;
    height: 172.5px;
  }

  .app_img img {
    width: 100%;
    height: 100%;
    margin-left: 92px;
  }

  .app_title {
    margin-top: 20px;
    font-size: 28px;
    color: #0D253E;
    text-align: center;
    font-weight: 500;
  }

  .app_text {
    margin-top: 15px;
    width: 355px;
    font-size: 22px;
    line-height: 35px;
    text-align: center;
    color: #0D253E;
    opacity: 0.7;
  }

  .big_img {
    background-image: url("../../static/img/big.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 485px;
    margin-top: 32px;
  }

  .big_text {
    font-size: 20px;
    color: #000;
    text-align: center;
    padding-top: 104px;
  }

  .big_text2 {
    font-size: 18px;
    color: #484848;
    text-align: center;
    margin-top: 10px;
  }

  .box2 {
    width: 70px;
    height: 70px;
  }

  .box2 img {
    width: 100%;
    height: 100%;
  }
  .box3{
    font-size: 14px;
    margin-left: 10px;
    width: 140px;
  }
  .box1 {
    display: flex;
    align-items: center;
  }

  .videos {
    width: 1200px;
    height: 534px;
    margin: 0 auto;
    padding-top: 60px;
    display: flex;
    align-items: center;
  }

  .company_title {
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(13, 37, 62, 1);
    line-height: 42px;
    margin: 120px 43px;
  }

  .company_text {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(13, 37, 62, 1);
    line-height: 32px;
    margin: -50px 43px;
  }

  .list {
    width: 1200px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .list_img {
    width: 120px;
    height: 120px;
    /* overflow: hidden; */
  }

  .list_img img {
    width: 100%;
    height: 100%;
  }

  .list_img:hover {
    transform: scale(1.2);
  }

  .store_box {
    width: 62.5%;
    margin-left: 18.75%;
    padding-top: 32px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .store_logo {
    width: 120px;
    height: 120px;
  }

  .store_logo img {
    width: 100%;
    height: 100%;
  }
  .div_center_p:hover .div_center{
    opacity: 0.8;
    
  }
  .div_img_h:hover{
    transform: scale(1.05);
  }
  .div_center{
    position: absolute;
    top:0;
    width:100%;
    height:100%;
    background:black;
    opacity: 0;
    color: white;
    font-size: 28px;
    text-align: center;
    /* display:flex; */
    align-items:center;
    transition: opacity 1.5s;
	-webkit-transition: 1.5s;
  }
  .div_box_back{
    width: 11%;
    margin-left: 0.5%;
    display: inline-block;
  }
  .div_box_back_one{
    margin-top: 10px;
    box-shadow: 0px 0px 24px 10px rgba(219, 219, 219, 0.5);
    background: white;
    padding-bottom: 15px;
  }
  .div_box_back_two{
    /* box-shadow: 0px 0px 24px 10px rgba(219, 219, 219, 0.5); */
    background: white;
    padding-bottom: 2.5%;
    height: 90%;
    /* margin-bottom: 10px; */
  }
  .div_content_text{
      font-size: 14px;
      margin-top: 10px;
    /* padding: 0px 23px;
    font-size: 13px; */
  }
  .div_content_icon{
      width: 15%;
      height: 100%;
  }
  .div_content_name{
    margin: 2% 0 0 3%;
  }
  .div_content_img{
    width: 84%;margin: 0 8%;
  }
  .div_center_back{
    position: relative;
    width: 23%;
    display: inline-block;
    margin-left: 1.6%;
    /* margin-left: 12px; */
  }
  .div_center_back_two{
    position: relative;
    width: 47.8%;
    /* display: inline-block; */
    /* margin-right: 12px; */
  }
  .img_class{
        -webkit-filter: blur(10px);
        filter: blur(10px);
    }
    .div_img_back{
        display: inline-block;
        width: 31.7%;

    }

</style>
<style>
    .login_dialog .el-dialog{
        background:none;
        webkit-box-shadow: 0 0 0 rgba(0, 0, 0, 0.3);
        box-shadow: 0 0 0 rgba(0, 0, 0, 0.3);
    }
</style>


// WEBPACK FOOTER //
// src/page/login.vue